import React from 'react';
import PropTypes from 'prop-types';
import styles from './Skeleton.css';
import classnames from 'classnames';

const ButtonSkeleton = ({
  size,
  width,
  alternative,
  className,
  sizeConfined,
  sizeWide,
}) => {
  const computedClass = [
    styles.element,
    styles.button,
    {
      [styles[`confined-button-${sizeConfined}`]]: sizeConfined,
      [styles[`wide-button-${sizeWide}`]]: sizeWide,
    },
  ];
  className && computedClass.push(className);
  alternative && computedClass.push(styles.alternative);
  switch (size) {
    case 'primary':
      computedClass.push(styles.buttonPrimary);
      break;
    case 'secondary':
      computedClass.push(styles.buttonSecondary);
      break;
    default:
      return null;
  }
  return (
    <span className={classnames(computedClass)} style={{ width }}>
      &nbsp;
    </span>
  );
};

ButtonSkeleton.displayName = 'ButtonSkeleton';

ButtonSkeleton.propTypes = {
  /** define a custom className for the skeleton */
  className: PropTypes.string,
  /** define the size [primary|secondary] */
  size: PropTypes.oneOf(['primary', 'secondary']),
  /** define the size for tablet and up [primary|secondary] */
  sizeConfined: PropTypes.oneOf(['primary', 'secondary']),
  /** define the size for desktop an up [primary|secondary] */
  sizeWide: PropTypes.oneOf(['primary', 'secondary']),
  /** Set if you want an alternative colour (#D9D9D9) */
  alternative: PropTypes.bool,
  /** define the width (in px) */
  width: PropTypes.number,
};

ButtonSkeleton.defaultProps = {
  size: 'primary',
};

export default ButtonSkeleton;
